import { useTranslation } from 'react-i18next'

import { Button, Modal } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const NotAllowTransactionModal = ({ show, onClose, onAccept }) => {
  const { t } = useTranslation()
  return (
    <Modal show={show} onClose={onClose} title={t('Operación no disponible')} size="m" blockOnClose>
      <Styles.Container>
        <h1>{t('¡Lo sentimos!')}</h1>
        <p>
          {t(
            'En este momento no podemos ofrecerte la opción de reembolso instantáneo. Ponte en contacto con la tienda para ver alternativas para tramitar tu devolución.'
          )}
        </p>
        <Button onClick={onAccept}>{t('Aceptar')}</Button>
      </Styles.Container>
    </Modal>
  )
}

export default NotAllowTransactionModal
